module.exports = {
  LSKEY_TOKEN: 'token',
  LSKEY_REFRESH_TOKEN: 'refreshToken',
  LSKEY_ACCESS_TOKEN_EXPIRY: 'accessTokenExpiration',
  INACTIVITY_TIMEOUT_MS: 30 * 60 * 1000,
  ACCESS_TOKEN_REFRESH_SKEW_MS: 2 * 60 * 1000,
  API_KEY: 'xJJrUaBumt7eVVwmIFwgZ4Ku13IcLYaJsMvPkFIjI4ofXahCFG8Vtnl9KTjE4Dnm',
}
